export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9820QFHD_white-269e72fa77a79e7e0ff8a475f9d6ef1f.webp";